var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 368.6,
    cy: 141.5,
    r: 46.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.2,49.5c-52.4.8-101.7,21.7-138.8,58.9-72.9,72.9-77.9,188.4-15.2,267.2l66.9-66.9c-26.8-41.6-22-97.8,14.4-134.1,19.8-19.9,46.2-31,74.2-31.5,25.8-.4,46.4-21.7,46-47.5-.4-25.8-21.6-46.4-47.5-46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.5,206.3h-.8c-25.5,0-46.3,20.5-46.8,46-.4,28-11.6,54.4-31.5,74.2-36.4,36.4-92.5,41.2-134.1,14.4l-66.9,66.9c36.5,29,80.8,43.6,125.1,43.6s102.9-19.6,142.1-58.8c37.1-37.1,58-86.4,58.9-138.9.4-25.8-20.2-47.1-46-47.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodifyLogo);
export default __webpack_public_path__ + "static/media/Codify-logo.2154d6f59494d51df354259b7bbc727d.svg";
export { ForwardRef as ReactComponent };